import _ from 'lodash';

import { getMaxDps } from 'shared/simcJsonTools';

export const pageMetadata = {
  home: {
    title: 'Raidbots - Optimize Your WoW Characters',
    description: 'The easiest way to use SimulationCraft. A resource for World of Warcraft players.',
  },
  stats: {
    title: 'Stat Weights - Raidbots',
    description: 'Generate stat weights for your character',
  },
  topgear: {
    title: 'Top Gear - Raidbots',
    description: 'Find the top gear combinations from your bags',
  },
  droptimizer: {
    title: 'Droptimizer - Raidbots',
    description: 'Find out what drops you should aim for',
  },
  gear: {
    title: 'Gear Compare - Raidbots',
    description: 'Compare different sets of gear',
  },
  relic: {
    title: 'Relic Compare - Raidbots',
    description: 'Compare relics and crucible traits for your artifact',
  },
  talents: {
    title: 'Talent Compare - Raidbots',
    description: 'Compare different talent builds',
  },
  quick: {
    title: 'Quick Sim - Raidbots',
    description: 'Run a quick sim to get your current DPS',
  },
  advanced: {
    title: 'Advanced Sim - Raidbots',
    description: 'Run (almost) any raw SimulationCraft script',
  },
  account: {
    title: 'Account - Raidbots',
  },
  auth: {
    title: 'Login - Raidbots',
  },
  privacy: {
    title: 'Privacy Policy - Raidbots',
  },
  reset: {
    title: 'Reset Settings - Raidbots',
  },
  developers: {
    title: 'Developers - Raidbots',
    description: 'Static data, Raidbots hooks, and more',
  },
  emailVerified: {
    title: 'Email Confirmed - Raidbots',
  },
  emailVerificationFailed: {
    title: 'Email Confirmation Failure - Raidbots',
  },
};

export const reportNames = {
  stats: 'Stat Weights',
  optimize: 'Top Gear',
  droptimizer: 'Droptimizer',
  gear: 'Gear Compare',
  relic: 'Relic Compare',
  talents: 'Talent Compare',
  quick: 'Quick Sim',
  advanced: 'Advanced Sim',
};

export const getReportTitleFromSummary = (summary) => {
  const titlePieces = [];

  if (!summary) {
    return 'Raidbots';
  }

  if (summary.title) {
    titlePieces.push(summary.title);
  } else {
    const reportName = reportNames[summary.type];
    titlePieces.push(reportName);
  }

  if (summary.player) {
    titlePieces.push(_.startCase(summary.player));
  }

  if (summary.dps) {
    titlePieces.push(`${summary.dps.toLocaleString()} DPS`);
  }

  titlePieces.push('Raidbots');

  return titlePieces.join(' - ');
};

export const getReportTitleFromJson = json => {
  const titlePieces = [];

  titlePieces.push(_.get(json, 'simbot.meta.title'));

  const player = _.startCase(_.get(json, 'simbot.meta.player') || _.get(json, 'sim.players[0].name'));

  if (player) {
    titlePieces.push(player);
  }

  const dps = _.round(getMaxDps(json));
  titlePieces.push(`${dps.toLocaleString()} DPS`);

  titlePieces.push('Raidbots');
  return titlePieces.join(' - ');
};
